import { render, staticRenderFns } from "./CollectionsSlider.vue?vue&type=template&id=63ef8445&"
import script from "./CollectionsSlider.vue?vue&type=script&lang=js&"
export * from "./CollectionsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports